<template>
  <v-card>
    <v-form ref="input_form">
      <v-row class="mx-auto">
        <!-- 検索条件フォーム -->
        <v-col cols="12" sm="12" md="12">
          <v-expansion-panels focusable flat>
            <v-expansion-panel>
              <v-expansion-panel-header>検索条件</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mx-auto">
                  <v-col cols="12" sm="12" md="12">
                    <v-row justify="start" class="mx-2">
                      <v-icon>fa-lightbulb</v-icon>
                      <span class="mx-2 my-5">注文状況</span>
                      <v-switch v-model="status_00" class="mx-2" label="注文確認待ち"></v-switch>
                      <v-switch v-model="status_01" class="mx-2" label="注文">></v-switch>
                      <v-switch v-model="status_03" class="mx-2" label="出荷済"></v-switch>
                      <template v-if="isCsv">
                        <v-switch v-model="status_04" class="mx-2" label="CSV出力済を含む"></v-switch>
                      </template>
                      <v-spacer></v-spacer>

                      <v-btn x-large class="ma-2" outlined color="dark" @click="clickSearch">
                        <v-icon>fa-search</v-icon>
                        <span class="ma-2">検索</span>
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="order_date_from"
                          label="注文日(開始)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="order_date_from"
                        @input="menu1 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="order_date_to"
                          label="注文日(終了)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="order_date_to"
                        @input="menu2 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-autocomplete
                      class="mx-2"
                      v-model="selectCustomer"
                      item-text="name"
                      item-value="code"
                      :items="customers"
                      label="得意先"
                      prepend-icon="fa-user"
                      return-object
                      :clearable="isOffice"
                      :readonly="!isOffice"
                      :search-input.sync="searchInput"
                      @change="searchInput=''"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="shipping_date_from"
                          label="出荷日(開始)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="shipping_date_from"
                        @input="menu3 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="20"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="shipping_date_to"
                          label="出荷日(終了)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="shipping_date_to"
                        @input="menu4 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu5"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="delivery_date_from"
                          label="着日(開始)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery_date_from"
                        @input="menu5 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu6"
                      :close-on-content-click="false"
                      :nudge-right="20"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="delivery_date_to"
                          label="着日(終了)"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery_date_to"
                        @input="menu6 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- 注文状況一覧 -->
        <v-col cols="12" sm="12" md="12">
          <template v-if="isLoaded">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              item-key="id"
              class="order_table"
              show-select
            >
              <template v-slot:item="{ item, isSelected }">
                <!-- <tr @click="showAlert(item)"> -->
                <tr @click="selectItem(item, isSelected)" :class="tableRowClass(item, isSelected)">
                  <td>
                    <v-simple-checkbox
                      v-show="isCsv"
                      :value="isSelected"
                      @input="toggleRow(item, isSelected)"
                      class="v-data-table__checkbox"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-chip :color="getColor(item.status)" dark>{{ item.status | statusString }}</v-chip>
                  </td>
                  <td>{{ item.order_id }}</td>
                  <td>{{ item.customer_name }}</td>
                  <td>{{ item.delivery_name }}</td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.standard }}</td>
                  <td>{{ item.jan_code }}</td>
                  <td>{{ item.quantity | moneyDelemiter }}</td>
                  <td>&yen;{{ item.unit | moneyDelemiter }}</td>
                  <td>&yen;{{ calTaxClass (item.tax_class,item.tax_fraction,item.unit * item.quantity) | moneyDelemiter}}</td>
                  <!-- <td>&yen;{{ (item.unit * item.quantity) | moneyDelemiter }}</td> -->
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-col>
        <v-col cols="12">
          <v-spacer></v-spacer>
        </v-col>

        <!-- メイン画面フッター -->
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <v-footer color="primary" dark padless fixed>
              <v-row justify="start" no-gutters>
                <v-btn x-large class="ma-2" outlined color="dark" v-scroll-to="'#top'">
                  <v-icon>fa-arrow-circle-up</v-icon>
                  <span class="ma-2">TOP</span>
                </v-btn>

                <template v-if="isCsv">
                  <template v-if="isOffice">
                    <v-btn x-large class="ma-2" outlined color="dark" @click="clickCSVFin">
                      <v-icon>fa-window-close</v-icon>
                      <span class="ma-2">CSVモード解除</span>
                    </v-btn>
                    <!-- <v-btn x-large class="ma-2" outlined color="dark" @click="clickLogin">
                      <v-icon>fa-file-download</v-icon>
                      <span class="ma-2">CSV出力</span>
                    </v-btn>-->

                    <template v-if="isOffice">
                      <template v-if="selected.length>0">
                        <v-form ref="csv_form">
                          <v-dialog v-model="csvOutputDialog" persistent max-width="80%">
                            <template v-slot:activator="{ on }">
                              <v-btn x-large class="ma-2" outlined color="dark" v-on="on">
                                <v-icon>fa-file-csv</v-icon>
                                <span class="ma-2">CSV出力</span>
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title>
                                <v-icon>fa-file-csv</v-icon>
                                <span class="headline ma-2">CSV出力</span>
                              </v-card-title>
                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="reportNo"
                                        label="伝票番号"
                                        prepend-icon="fa-file-alt"
                                        clearable
                                        @keyup.enter="downloadCSV"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="csvOutputDialog = false">閉じる</v-btn>
                                <v-btn color="primary" @click="downloadCSV">実行</v-btn>
                              </v-card-actions>
                              <Dialog ref="dialog" />
                            </v-card>
                          </v-dialog>
                        </v-form>
                      </template>
                    </template>
                  </template>
                </template>
                <template v-else>
                  <v-btn x-large class="ma-2" outlined color="dark" @click="clickOrder">
                    <v-icon>fa-edit</v-icon>
                    <span class="ma-2">新規注文</span>
                  </v-btn>
                  <template v-if="isOffice">
                    <v-btn x-large class="ma-2" outlined color="dark" @click="clickCSV">
                      <v-icon>fa-file-csv</v-icon>
                      <span class="ma-2">CSV</span>
                    </v-btn>
                  </template>
                </template>
              </v-row>
            </v-footer>
          </v-row>
        </v-col>

        <!-- 注文入力ダイアログ -->
        <v-col>
          <v-row justify="center">
            <v-dialog
              v-model="orderDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar fixed dark color="primary">
                  <v-btn icon dark @click="clickClose">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>注文入力画面</v-toolbar-title>

                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="clickClose">
                      <v-icon>fa-times-circle</v-icon>
                      <span class="ma-2">閉じる</span>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-row class="mx-auto">
                  <v-col cols="12" sm="3" md="3">
                    <template v-if="!isRegist">
                      <v-text-field
                        v-model="order_id"
                        label="注文番号"
                        prepend-icon="fa-keyboard"
                        readonly
                        tabindex="-1"
                        disabled
                      ></v-text-field>
                    </template>
                  </v-col>
                  <v-col cols="12" sm="9" md="9"></v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu11"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="order_date"
                          label="注文日"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="order_date"
                        @input="menu11 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      ref="menu"
                      v-model="menu12"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="order_date_time"
                          label="注文時分"
                          prepend-icon="access_time"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menu12"
                        v-model="order_date_time"
                        full-width
                        @click:minute="$refs.menu.save(time)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu13"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="delivery_date"
                          label="希望着日"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery_date"
                        @input="menu13 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-menu
                      v-model="menu14"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="shipping_date"
                          label="出荷日"
                          prepend-icon="event"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="shipping_date"
                        @input="menu14 = false"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="customer_code"
                      item-text="name"
                      item-value="code"
                      :items="customers"
                      label="得意先"
                      prepend-icon="fa-user"
                      return-object
                      :rules="customerRules"
                      :clearable="isOffice"
                      :disabled="!isOffice"
                      @change="changeCustomer"
                      @click:clear="clearCustomer"
                    ></v-autocomplete>

                    <v-autocomplete
                      v-model="delivery_code"
                      item-text="name"
                      item-value="code"
                      :items="deliverys"
                      label="納入先"
                      prepend-icon="fa-store"
                      return-object
                      clearable
                      :disabled=" !isVisible"
                      :rules="deliveryRules"
                      @click:clear="delivery_code = null"
                    ></v-autocomplete>

                    <v-autocomplete
                      v-model="product_code"
                      item-text="name"
                      item-value="code"
                      :items="products"
                      label="商品"
                      prepend-icon="fa-shopping-cart"
                      return-object
                      :rules="productRules"
                      clearable
                      :disabled=" !isVisible"
                      @change="changeProductCode"
                      @click:clear="product_code = null"
                    ></v-autocomplete>
                    <v-text-field
                      v-model="standard"
                      label="規格"
                      prepend-icon="fa-info-circle"
                      readonly
                      tabindex="-1"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="jan_code"
                      label="JANコード"
                      prepend-icon="fa-qrcode"
                      readonly
                      tabindex="-1"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <div>
                      <v-icon>fa-image</v-icon>
                      <span class="mx-2 my-5">商品イメージ</span>
                    </div>
                    <v-container fluid>
                      <v-img :src="imageSrc" aspect-ratio="1.7"></v-img>
                    </v-container>
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <div>
                      <v-icon>fa-list-alt</v-icon>
                      <span class="mx-2 my-5">商品概要</span>
                    </div>
                    <v-container disabled fluid>{{item_remark}}</v-container>
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="std_quantity"
                      label="入数"
                      prepend-icon="fa-th"
                      readonly
                      tabindex="-1"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="case_num"
                      label="ケース"
                      prepend-icon="fa-cubes"
                      :readonly="case_readonly"
                      :clearable="case_clearable"
                      :disabled="product_code==null || std_quantity<=0 || !isVisible"
                      @change="changeInput"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="quantity"
                      label="数量"
                      prepend-icon="fa-shopping-cart"
                      :readonly="quantity_readonly"
                      :clearable="quantity_clearable"
                      :disabled="product_code==null || std_quantity>0 || !isVisible"
                      @change="changeInput"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <template v-if="isOffice">
                      <v-text-field
                        v-model="unit"
                        label="単価"
                        prepend-icon="fa-at"
                        clearable
                        :disabled="product_code==null"
                        @change="changeInput"
                      ></v-text-field>
                    </template>
                    <template v-else>
                      <v-text-field
                        v-model="unit"
                        label="単価"
                        prepend-icon="fa-at"
                        readonly
                        :disabled="product_code==null || !isVisible"
                      ></v-text-field>
                    </template>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="price"
                      label="金額(税込)"
                      prepend-icon="fa-yen-sign"
                      readonly
                      tabindex="-1"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="tax"
                      label="課税区分"
                      prepend-icon="fa-clipboard-check"
                      readonly
                      tabindex="-1"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-container fluid>
                      <v-textarea
                        v-model="remark"
                        clearable
                        clear-icon="cancel"
                        prepend-icon="fa-edit"
                        label="備考"
                        value
                        :disabled=" !isVisible"
                      ></v-textarea>
                    </v-container>
                  </v-col>
                  <v-col cols="12">
                    <v-spacer></v-spacer>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-row>
                      <v-footer color="primary" dark padless fixed>
                        <v-row justify="start" no-gutters>
                          <template v-if="!isRegist">
                            <v-btn x-large class="ma-2" color="warning" @click="clickStatus">
                              <v-icon>fa-lightbulb</v-icon>
                              <span class="ma-2">{{status | statusString }}</span>
                            </v-btn>
                          </template>

                          <template v-if="isVisible">
                            <v-btn x-large class="ma-2" outlined color="dark" @click="clickRegist">
                              <v-icon>fa-database</v-icon>
                              <span class="ma-2">登録</span>
                            </v-btn>
                          </template>
                          <template v-if="isDelete">
                            <v-btn x-large class="ma-2" outlined color="dark" @click="clickDelete">
                              <v-icon>fa-trash-alt</v-icon>
                              <span class="ma-2">削除</span>
                            </v-btn>
                          </template>

                          <template v-if="isOfficeAndCustomerSelect">
                            <v-form ref="adddelivery_form">
                              <v-dialog v-model="deliveryDialog" persistent max-width="80%">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    x-large
                                    class="ma-2"
                                    outlined
                                    color="dark"
                                    v-on="on"
                                    @click="openDeliveryDialog"
                                  >
                                    <v-icon>fa-store</v-icon>
                                    <v-icon>fa-plus-circle</v-icon>
                                    <span class="ma-2">納入先追加</span>
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <v-icon>fa-store</v-icon>
                                    <span class="headline ma-2">納入先追加</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-text-field
                                            v-model="customer_name"
                                            label="得意先"
                                            prepend-icon="fa-user"
                                            readonly
                                          ></v-text-field>

                                          <v-text-field
                                            v-model="addDelivery"
                                            label="納入先名"
                                            :rules="addDeliveryRules"
                                            prepend-icon="fa-store"
                                            clearable
                                            @keyup.enter="clickDeliveryDialogRegist"
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="deliveryDialog = false">閉じる</v-btn>
                                    <v-btn color="primary" @click="clickDeliveryDialogRegist">登録</v-btn>
                                  </v-card-actions>
                                  <Dialog ref="dialog" />
                                </v-card>
                              </v-dialog>
                            </v-form>
                          </template>

                          <template v-if="isOfficeAndCustomerSelect">
                            <v-form ref="addProduct_form">
                              <v-dialog v-model="productDialog" persistent max-width="80%">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    x-large
                                    class="ma-2"
                                    outlined
                                    color="dark"
                                    v-on="on"
                                    @click="openproductDialog"
                                  >
                                    <v-icon>fa-shopping-cart</v-icon>
                                    <v-icon>fa-plus-circle</v-icon>
                                    <span class="ma-2">商品追加</span>
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <v-icon>fa-store</v-icon>
                                    <span class="headline ma-2">商品追加</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-text-field
                                            v-model="customer_name"
                                            label="得意先"
                                            prepend-icon="fa-user"
                                            readonly
                                          ></v-text-field>

                                          <v-autocomplete
                                            v-model="addProduct"
                                            item-text="name"
                                            item-value="code"
                                            :items="productsall"
                                            label="商品"
                                            :rules="addProductCodeRules"
                                            prepend-icon="fa-shopping-cart"
                                            return-object
                                            clearable
                                            @keyup.enter="clickProductDialogRegist"
                                          ></v-autocomplete>
                                          <v-text-field
                                            v-model="addUnit"
                                            label="単価"
                                            :rules="addUnitRules"
                                            prepend-icon="fa-at"
                                            clearable
                                            @change="changeAddUnit"
                                            @keyup.enter="clickProductDialogRegist"
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="productDialog = false">閉じる</v-btn>
                                    <v-btn color="primary" @click="clickProductDialogRegist">登録</v-btn>
                                  </v-card-actions>
                                  <Dialog ref="dialog" />
                                </v-card>
                              </v-dialog>
                            </v-form>
                          </template>

                          <v-btn x-large class="ma-2" outlined color="dark" @click="clickClose">
                            <v-icon>fa-times-circle</v-icon>
                            <span class="ma-2">閉じる</span>
                          </v-btn>
                        </v-row>
                      </v-footer>
                    </v-row>
                  </v-col>
                  <v-col>
                    <Dialog ref="dialog" />
                  </v-col>
                </v-row>
              </v-card>
            </v-dialog>
          </v-row>
        </v-col>
        <v-col>
          <Dialog ref="dialog" />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<style scoped>
.v-navigation-drawer {
  transition: none !important;
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { VMoney } from 'v-money'
import Dialog from '@/components/Dialog.vue'

export default {
  components: {
    Dialog
  },
  directives: { money: VMoney },
  mounted: function () {
    let $func = 'mounted'
    if (this.DEBUG) {
      console.log(
        '【' + $func + '】 ' + '(start)----------------------------------'
      )
    }
    this.setEditMode(0) // 操作モードの初期化
    axios
      .post('/laravel/public/master/customer')
      .then(response => {
        this.customers = response.data
        this.selectCustomer.code = this.getCustomer()
        // 注文状況一覧の取得
        this.getList()
      })
      .catch(error => {
        this.err = error.response.data.errors
        this.resetOverlay()
        this.showDialog(
          'データベースアクセスエラー',
          '得意先リストの取得に失敗しました\nシステム管理者に連絡してください'
        )
      })
  },
  computed: {
    isLoaded () {
      let $func = 'isLoaded'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      return this.loadFlag
    },
    /**
     * 事務所ユーザ／得意先選択判定
     */
    isOfficeAndCustomerSelect () {
      let $func = 'isOfficeAndCustomerSelect'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      // 得意先未選択
      if (!this.customer_code) {
        // 非表示
        return false
      }

      console.log('this.isOfficeKind()=' + this.isOfficeKind())
      console.log('this.customer_code.code=' + this.customer_code.code)
      if (
        this.isOfficeKind() && // 事務所ユーザ
        this.customer_code.code // 得意先設定中
      ) {
        return true
      }
      return false
    },
    /**
     * 得意先ユーザ表示有無チェック
     */
    isVisible () {
      let $func = 'isVisible'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      // 得意先ユーザ
      if (!this.isOfficeKind()) {
        // 注文確認中？
        if (this.status === '0') {
          // 表示
          return true
        } else {
          // 非表示
          return false
        }
      }
      // 事務所ユーザ表示
      return true
    },

    /**
     * ボタン表示判断
     */
    isDelete () {
      let $func = 'isDelete'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      // 新規モードの場合、非表示
      if (this.isRegist) {
        return false
      }
      // 得意先ユーザ
      if (!this.isOfficeKind()) {
        // 注文確認中？
        if (this.status === '0') {
          // 表示
          return true
        } else {
          // 非表示
          return false
        }
      }
      // 事務所ユーザ表示
      return true
    }
  },
  methods: {
    /**
     * 注文状況一覧の取得
     */
    getList () {
      let $func = 'getList'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      axios
        .post('/laravel/public/order/list', {
          customer_code: this.selectCustomer.code,
          status_00: this.status_00,
          status_01: this.status_01,
          status_02: this.status_02,
          status_03: this.status_03,
          status_04: !this.isCsv ? 1 : this.status_04,
          order_date_from: this.order_date_from,
          order_date_to: this.order_date_to,
          shipping_date_from: this.shipping_date_from,
          shipping_date_to: this.shipping_date_to,
          delivery_date_from: this.delivery_date_from,
          delivery_date_to: this.delivery_date_to,
          class: this.getUserKind()
        })
        .then(response => {
          this.items = response.data
          // 1秒待つ
          setTimeout(() => {
            this.resetOverlay()
            this.loadFlag = true
          }, 1000)
          console.log(JSON.stringify(this.items))
        })
        .catch(error => {
          this.err = error.response.data.errors
          this.resetOverlay()
          this.showDialog(
            'データベースアクセスエラー',
            '注文状況リストの取得に失敗しました\nシステム管理者に連絡してください'
          )
        })
      // 正常にPOST出来た場合にオーバーレイ設定
      this.setOverlay()
      this.loadFlag = false
    },
    getEndDate () {
      if (this.DEBUG) {
        console.log('■ getEndDate(start)----------------------------------')
      }

      return new Date().toISOString().slice(0, 10)
    },
    /**
     * CSVモード移行
     */
    clickCSV () {
      let $func = 'clickCSV'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      this.setEditMode(3) // CSVモード設定
      // チェックボックスの初期化
      this.selected = []
      // 再検索を行う
      this.clickSearch()
    },
    /**
     * CSVモード終了
     */
    clickCSVFin () {
      let $func = 'clickCSVFin'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      this.status_04 = false // CSV出力済含むをOFF
      this.setEditMode(2) // 編集モード設定
      // チェックボックスの初期化
      this.selected = []
      // 再検索を行う
      this.clickSearch()
    },

    /**
     * 新規注文ボタンクリック
     */
    clickOrder () {
      let $func = 'clickOrder'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      this.setEditMode(1) // 操作モード 新規
      // バリデーションの初期化
      this.$refs.input_form.resetValidation()

      // 初期値設定
      this.order_id = ''
      this.order_date = new Date().toISOString().substr(0, 10)
      this.order_date_time = moment().format('HH:mm')
      this.delivery_date = new Date().toISOString().substr(0, 10)
      this.shipping_date = new Date().toISOString().substr(0, 10)

      this.jan_code = null
      this.standard = null
      this.std_quantity = null
      this.quantity = null
      this.unit = null
      this.case_num = null
      this.std_quantity = null
      this.price = null
      this.imageSrc = 'img.php'

      this.tax_class = null
      this.tax = null

      this.tax_fraction = null
      this.item_remark = null
      this.remark = ''

      // 注文入力ダイアログ表示
      this.orderDialog = true
      this.dlgOverlay = true

      // 得意先選択クリア
      this.clearCustomer()

      // 1秒待つ
      setTimeout(() => {
        // 注文状態の初期化
        if (this.isOfficeKind()) {
          this.status = '1'
          this.customer_code = null
          this.resetOverlay()
        } else {
          this.status = '0'
          this.customer_code = { code: '', name: '' }
          this.customer_code.code = this.getCustomer()
          this.searchDelivery()
        }
        this.delivery_code = null
        this.product_code = null
      }, 1000)

      //   this.$router.push({ path: 'order' })
    },
    /**
     * 注文状況クリックイベント処理
     */
    clickStatus () {
      let $func = 'clickStatus'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      if (this.isOfficeKind()) {
        this.setOverlay()
        let upStatus = '1'

        switch (Number(this.status)) {
          case 0:
            upStatus = '1'
            break
          case 1:
            upStatus = '3'
            break
          case 2:
            upStatus = '3'
            break
          case 3:
            upStatus = '0'
            break
        }

        axios
          .post('/laravel/public/order/status', {
            id: this.id,
            status: upStatus
          })
          .then(response => {
            // 1秒待つ
            setTimeout(() => {
              // 出荷状況再検索要
              this.refresh = true
              // 出荷状況の表示更新
              this.status = upStatus
              this.resetOverlay()
            }, 1000)
          })
          .catch(error => {
            this.resetOverlay()
            this.err = error.response.data.errors
            this.showDialog(
              'データベースアクセスエラー',
              '出荷状況の更新に失敗しました \nシステム管理者に連絡してください'
            )
          })
      }
    },
    /**
     * 登録処理
     */
    clickRegist () {
      let $func = 'clickRegist'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      if (this.$refs.input_form.validate()) {
        // 3桁カンマ表示削除
        this.resetCommaDelimiter()

        if (this.remark == null) {
          this.remark = ''
        }
        // オーバーレイ表示
        this.setOverlay()
        axios
          .post('/laravel/public/order/regist', {
            id: this.id,
            status: this.status,
            order_date: this.order_date + ' ' + this.order_date_time,
            delivery_date: this.delivery_date,
            shipping_date: this.shipping_date,
            customer_code: this.customer_code.code,
            delivery_code: this.delivery_code.code,
            product_code: this.product_code.code,
            case: this.case_num,
            quantity: this.quantity,
            unit: this.unit,
            excluding_tax: this.excluding_tax,
            remark: this.remark
          })
          .then(response => {
            // 1秒待つ
            setTimeout(() => {
              // 再検索要を設定
              this.refresh = true
              if (!this.isRegist) {
                // 注文入力画面を閉じる
                this.clickClose()
              } else {
                // 「注文入力画面」入力フィールドの初期化
                this.clearInput()
                // 3桁カンマ表示
                this.setCommaDelimiter()
                // オーバーレイ消去
                this.resetOverlay()
              }
            }, 1000)

            // メール送信(得意先のみ)
            console.log('this.isOfficeKind = ' + this.isOfficeKind())

            if (!this.isOfficeKind()) {
              console.log('得意先ユーザです、メール送信を実施します')
              let params = new URLSearchParams()
              let $obj = null
              // 得意先コードよりレコードを検索
              $obj = this.customers.find(
                v => v.code === this.customer_code.code
              )
              console.log('MAIL:this.customer_code.name = ' + $obj.name)
              params.append('customer_name', $obj.name)
              // 商品コードよりレコードを検索
              $obj = this.products.find(v => v.code === this.product_code.code)
              console.log('MAIL:this.product_code.name = ' + $obj.name)
              params.append('product_name', $obj.name)
              // 得意先のメール
              params.append('mail_to', this.gatUserMailAdr())
              axios
                .post('/mail.php', params)
                .then(response => {
                  console.log('メール送信が完了しました')
                })
                .catch(error => {
                  this.resetOverlay()
                  this.err = error.response.data.errors
                  console.log(
                    '登録完了メール送信に失敗しました \n処理を続行します'
                  )
                })
            } else {
              console.log('事務所ユーザのため、メール送信は実施しません')
            }
          })
          .catch(error => {
            this.resetOverlay()
            this.err = error.response.data.errors
            this.showDialog(
              'データベースアクセスエラー',
              '注文情報の登録に失敗しました \nシステム管理者に連絡してください'
            )
          })
      }
    },
    /**
     * 削除ボタンクリック
     */
    clickDelete () {
      let $func = 'clickDelete'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      // オーバーレイ表示
      this.setOverlay()
      axios
        .post('/laravel/public/order/delete', {
          id: this.id
        })
        .then(response => {
          // 1秒待つ
          setTimeout(() => {
            // オーバーレイ消去
            this.resetOverlay()
            // 「注文入力」ダイアログを閉じる
            this.clickClose()
            // 再検索を行う
            this.clickSearch()
          }, 1000)
        })
        .catch(error => {
          this.resetOverlay()
          this.err = error.response.data.errors
          this.showDialog(
            'データベースアクセスエラー',
            '注文情報の削除に失敗しました \nシステム管理者に連絡してください'
          )
        })
    },
    /**
     * 検索ボタンクリックイベント処理
     */
    clickSearch () {
      let $func = 'clickSearch'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      if (!this.selectCustomer) {
        this.selectCustomer = { name: '', code: '' }
      }
      // 注文状況一覧の取得
      this.getList()
    },
    toggleRow (item, isSelected) {
      let $func = 'toggleRow'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      if (this.selected.includes(item)) {
        // item が含まれていたら除去する
        this.selected = this.selected.filter(v => v !== item)
      } else {
        // item を追加する
        this.selected.push(item)
      }
      if (this.DEBUG) {
        console.log('[' + $func + ']' + 'this.selected  = ' + isSelected)
        console.log(
          '[' +
            $func +
            ']' +
            'this.selected  = ' +
            JSON.stringify(this.selected)
        )
      }
    },
    /**
     * 入力フィールド初期化(新規注文入力 連続入力用)
     */
    clearInput () {
      let $func = 'clearInput'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      this.id = null
      this.order_id = null
      this.status = '0'

      this.product_code = null

      this.jan_code = null
      this.standard = null
      this.std_quantity = null
      this.quantity = null
      this.unit = null
      this.price = null
      this.case_num = null
      this.remark = ''
      // ケース・数量入力コントロール
      this.inputConrl()
      // イメージ画像変更
      this.imageSrc = 'img.php?id=none'

      this.tax_class = null
      this.tax = null

      this.tax_fraction = null
      this.item_remark = null
    },
    /**
     * 行選択イベント処理
     */
    selectItem (item, isSelected) {
      let $func = 'selectItem'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      // CSVモード以外
      if (!this.isCsvMode()) {
        this.refresh = false // 再検索フラグ初期化
        this.setEditMode(2) // 操作モード←修正

        // 選択情報設定
        this.id = item.id
        this.order_id = item.order_id
        this.status = item.status
        // 日付初期化
        this.order_date = null
        this.delivery_date = null
        this.shipping_date = null
        if (item.order_date) {
          console.log('[' + $func + ']' + 'item.order_date=' + item.order_date)
          this.order_date =
            item.order_date.length > 10 ? item.order_date.substr(0, 10) : ''
          this.order_date_time =
            item.order_date.length > 16 ? item.order_date.substr(11, 5) : ''
        }
        if (item.delivery_date) {
          this.delivery_date =
            item.delivery_date.length > 10
              ? item.delivery_date.substr(0, 10)
              : ''
        }
        if (item.shipping_date) {
          this.shipping_date =
            item.shipping_date.length > 10
              ? item.shipping_date.substr(0, 10)
              : ''
        }

        this.customer_code = { name: '', code: '' }
        this.customer_code.code = item.customer_code
        this.delivery_code = { name: '', code: '' }
        this.delivery_code.code = item.delivery_code
        this.product_code = { name: '', code: '' }
        this.product_code.code = item.product_code

        this.jan_code = item.jan_code
        this.standard = item.standard

        this.std_quantity = item.std_quantity
        this.quantity = item.quantity
        this.unit = item.unit
        this.case_num = item.case
        // 3桁カンマ表示解除
        this.resetCommaDelimiter()

        // ケース・数量入力コントロール
        this.inputConrl()

        // イメージ画像変更
        if (this.product_code.code) {
          this.imageSrc = 'img.php?id=' + this.product_code.code
        }

        this.tax_class = item.tax_class
        this.tax = this.getTaxClass(this.tax_class)

        this.tax_fraction = item.tax_fraction
        this.item_remark = item.item_remark
        this.remark = item.remark
        if (!this.remark) {
          this.remark = ''
        }

        // 金額計算
        this.changePrice()
        // 3桁カンマ表示
        this.setCommaDelimiter()

        //   this.$router.push('/order')
        this.orderDialog = true
        this.setOverlay()
        this.searchDelivery()
      } else {
        isSelected = !isSelected
        this.toggleRow(item, isSelected)
      }
    },
    /**
     * 数量など入力イベント処理
     */
    changeInput () {
      let $func = 'changeInput'

      try {
        if (this.DEBUG) {
          console.log(
            '【' + $func + '】 ' + '(start)----------------------------------'
          )
        }

        if (this.DEBUG) {
          console.log(
            '[' +
              $func +
              ']' +
              'this.case_num = ' +
              this.case_num +
              ' ' +
              'this.quantity = ' +
              this.quantity
          )
        }
        // 3桁カンマ表示解除
        this.resetCommaDelimiter()
        // 入数>0の場合
        if (this.std_quantity > 0) {
          this.quantity = this.case_num * this.std_quantity
        }
        // 金額計算
        this.changePrice()
        // 3桁カンマ表示
        this.setCommaDelimiter()
      } catch {
        console.log('[' + $func + '] ' + 'アプリケーションエラーが発生しました')
        this.quantity = null
        this.case_num = null
      }
    },
    /**
     * 3桁カンマ表示解除(0補正)
     */
    resetCommaDelimiter () {
      // 全角半角変換
      this.std_quantity = this.hankaku2Zenkaku(this.std_quantity)
      this.case_num = this.hankaku2Zenkaku(this.case_num)
      this.quantity = this.hankaku2Zenkaku(this.quantity)
      this.unit = this.hankaku2Zenkaku(this.unit)
      this.price = this.hankaku2Zenkaku(this.price)

      // 入数
      this.std_quantity = this.removeCommaDelimiter(this.std_quantity)
      if (!this.std_quantity) {
        this.std_quantity = 0
      } else if (isNaN(this.std_quantity)) {
        this.std_quantity = 0
      }
      // ケース
      this.case_num = this.removeCommaDelimiter(this.case_num)
      if (!this.case_num) {
        this.case_num = 0
      } else if (isNaN(this.case_num)) {
        this.case_num = 0
      }
      // 数量
      this.quantity = this.removeCommaDelimiter(this.quantity)
      if (!this.quantity) {
        this.quantity = 0
      } else if (isNaN(this.quantity)) {
        this.quantity = 0
      }
      // 単価
      this.unit = this.removeCommaDelimiter(this.unit)
      if (!this.unit) {
        this.unit = 0
      } else if (isNaN(this.unit)) {
        this.unit = 0
      }
      // 金額
      this.price = this.removeCommaDelimiter(this.price)
      if (!this.price) {
        this.price = 0
      } else if (isNaN(this.price)) {
        this.price = 0
      }
    },
    /**
     * 3桁カンマ表示
     */
    setCommaDelimiter () {
      // 入数
      if (isNaN(this.std_quantity)) {
        this.std_quantity = null
      } else {
        if (this.std_quantity <= 0) {
          this.std_quantity = null
        } else {
          this.std_quantity = this.insertCommaDelimiter(this.std_quantity)
        }
      }
      // ケース
      if (isNaN(this.case_num)) {
        this.case_num = null
      } else {
        if (this.case_num <= 0) {
          this.case_num = null
        } else {
          this.case_num = this.insertCommaDelimiter(this.case_num)
        }
      }
      // 数量
      if (isNaN(this.quantity)) {
        this.quantity = null
      } else {
        if (this.quantity <= 0) {
          this.quantity = null
        } else {
          this.quantity = this.insertCommaDelimiter(this.quantity)
        }
      }
      // 単価
      if (isNaN(this.unit)) {
        this.unit = null
      } else {
        if (this.unit <= 0) {
          this.unit = null
        } else {
          this.unit = this.insertCommaDelimiter(this.unit)
        }
      }
      // 金額
      if (isNaN(this.price)) {
        this.price = null
      } else {
        if (this.price <= 0) {
          this.price = null
        } else {
          this.price = this.insertCommaDelimiter(this.price)
        }
      }
    },
    /**
     * 金額計算処理
     */
    changePrice () {
      let $func = 'changePrice'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      //   alert('金額再計算：' + this.price)
      try {
        if (this.DEBUG) {
          console.log(
            '[' +
              $func +
              '] ' +
              'this.unit = ' +
              this.unit +
              ' this.quantity = ' +
              this.quantity
          )
        }

        // 税抜価格計算
        this.excluding_tax = this.unit * this.quantity

        // 税込価格計算
        this.price = this.calTaxClass(
          this.tax_class,
          this.tax_fraction,
          this.excluding_tax
        )
      } catch {
        console.log('[' + $func + '] ' + 'アプリケーションエラーが発生しました')
        this.price = null
      }
    },
    /**
     * 商品追加 単価変更
     */
    changeAddUnit () {
      let $func = 'changeAddUnit'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      let unit = this.addUnit
      if (!unit) {
        this.addUnit = null
      } else {
        unit = this.hankaku2Zenkaku(unit)
        unit = this.removeCommaDelimiter(unit)
      }
      this.addUnit = this.insertCommaDelimiter(unit)
    },
    /**
     * ボタンクリックイベント
     */
    clickbtn: function (btn) {
      let $func = 'clickbtn'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      switch (btn.method) {
        case 'Close':
          this.clickClose()
          break
      }
    },

    /**
     * 注文ダイアログを閉じる処理
     */
    clickClose () {
      let $func = 'clickClose'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }
      // ダイアログを閉じる
      this.orderDialog = false
      // DB更新あり
      if (this.refresh) {
        this.clickSearch() // 検索
        this.refresh = false // 再検索フラグ初期化
      }
    },

    /**
     * 納入先リスト取得処理
     */
    searchDelivery () {
      let $func = 'searchDelivery'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      if (!this.customer_code) {
        return
      }

      console.log('this.customer_code.code = ' + this.customer_code.code)

      axios
        .post('/laravel/public/master/delivery', {
          customer_code: this.customer_code.code
        })
        .then(response => {
          //   alert('response:' + JSON.stringify(response.data))
          if (this.DEBUG) {
            console.log(
              '[' +
                $func +
                ']' +
                'deliverys  = ' +
                JSON.stringify(response.data)
            )
          }
          this.deliverys = response.data

          axios
            .post('/laravel/public/master/product', {
              customer_code: this.customer_code.code
            })
            .then(response => {
              this.products = response.data
              // 1秒待つ
              setTimeout(() => {
                this.resetOverlay()
              }, 1000)
            })
            .catch(error => {
              this.err = error.response.data.errors
              this.resetOverlay()
              this.showDialog(
                'データベースアクセスエラー',
                '商品リストの取得に失敗しました\nシステム管理者に連絡してください'
              )
            })
        })
        .catch(error => {
          this.err = error.response.data.errors
          // 1秒待つ
          setTimeout(() => {
            this.resetOverlay()
            this.showDialog(
              'データベースアクセスエラー',
              '納入先リストの取得に失敗しました\nシステム管理者に連絡してください'
            )
          }, 1000)
        })
      this.setOverlay()
    },
    /**
     * 得意先クリア処理
     */
    clearCustomer () {
      let $func = 'clearCustomer'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      this.delivery_code = null
      this.deliverys = []

      this.product_code = null
      this.products = []

      // 商品コード変更処理
      this.changeProductCode()
    },
    /**
     * 得意先コード変更処理
     */
    changeCustomer () {
      // 得意先コード初期化時処理
      this.clearCustomer()

      // 納入先リスト取得
      this.searchDelivery()
    },
    /**
     * 商品追加ダイアログOPEN
     */
    openproductDialog () {
      let $func = 'openproductDialog'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      try {
        // 得意先名を検索して表示する
        let $obj = this.customers.find(v => v.code === this.customer_code.code)
        this.customer_name = $obj.name

        // ダイアログOPEN
        this.productDialog = true
        this.setOverlay()

        // 初期化
        if (!this.product_code) {
          this.addProduct = null
        } else {
          this.addProduct = { name: '', code: '' }
          this.addProduct.code = this.product_code.code
        }

        this.addUnit = this.unit

        // バリデーションの初期化
        this.$refs.addProduct_form.resetValidation()

        // 全商品マスタリストの取得
        axios
          .post('/laravel/public/master/productall')
          .then(response => {
            // 1秒待つ
            setTimeout(() => {
              this.productsall = response.data
              this.resetOverlay()
            }, 1000)
          })
          .catch(error => {
            this.resetOverlay()
            this.err = error.response.data.errors
            this.showDialog(
              'データベースアクセスエラー',
              '商品の追加に失敗しました \nシステム管理者に連絡してください'
            )
          })
      } catch (e) {
        this.resetOverlay()
        // エラーメッセージ
        this.showDialog(
          'アプリケーションエラーが発生しました',
          e.message + ' \nシステム管理者に連絡してください'
        )
      }
    },
    /**
     * 商品追加ダイアログ：登録クリックイベント
     */
    clickProductDialogRegist () {
      let $func = 'clickProductDialogRegist'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      if (this.$refs.addProduct_form.validate()) {
        if (!this.addProduct.code) {
          this.showDialog('入力エラー', '商品が選択されていません')
          return
        }
        this.setOverlay()

        axios
          .post('/laravel/public/master/addunit', {
            customer_code: this.customer_code.code,
            product_code: this.addProduct.code,
            unit: this.removeCommaDelimiter(this.addUnit)
          })
          .then(response => {
            // 登録商品コードの設定
            this.product_code = { name: '', code: '' }
            this.product_code.code = this.addProduct.code
            // 商品マスタリスト取得
            axios
              .post('/laravel/public/master/product', {
                customer_code: this.customer_code.code
              })
              .then(response => {
                this.products = response.data
                // 1秒待つ
                setTimeout(() => {
                  // マスタ情報更新
                  this.changeProductCode()
                  this.resetOverlay()
                  // ダイアログを閉じる
                  this.productDialog = false
                }, 1000)
              })
              .catch(error => {
                this.err = error.response.data.errors
                this.resetOverlay()
                this.showDialog(
                  'データベースアクセスエラー',
                  '商品リストの取得に失敗しました\nシステム管理者に連絡してください'
                )
              })
          })
          .catch(error => {
            this.resetOverlay()
            this.err = error.response.data.errors
            this.showDialog(
              'データベースアクセスエラー',
              '商品の追加に失敗しました \nシステム管理者に連絡してください'
            )
          })
      }
    },
    /**
     * 納入先追加ダイアログ：登録クリックイベント
     */
    clickDeliveryDialogRegist () {
      let $func = 'clickDeliveryDialogRegist'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      if (this.$refs.adddelivery_form.validate()) {
        this.setOverlay()

        axios
          .post('/laravel/public/master/adddelivery', {
            customer_code: this.customer_code.code,
            name: this.addDelivery
          })
          .then(response => {
            // 納入先コードの設定
            this.delivery_code = { name: '', code: '' }
            this.delivery_code.code = response.data.code

            // 納入先マスタリスト取得
            axios
              .post('/laravel/public/master/delivery', {
                customer_code: this.customer_code.code
              })
              .then(response => {
                this.deliverys = response.data
                // 1秒待つ
                setTimeout(() => {
                  this.resetOverlay()
                  // ダイアログを閉じる
                  this.deliveryDialog = false
                }, 1000)
              })
              .catch(error => {
                this.err = error.response.data.errors
                this.resetOverlay()
                // ダイアログを閉じる
                this.deliveryDialog = false
                this.showDialog(
                  'データベースアクセスエラー',
                  '納入先リストの取得に失敗しました \nシステム管理者に連絡してください'
                )
              })
          })
          .catch(error => {
            this.resetOverlay()
            this.deliveryDialog = false
            this.err = error.response.data.errors
            this.showDialog(
              'データベースアクセスエラー',
              '納入先の追加に失敗しました \nシステム管理者に連絡してください'
            )
          })
      }
    },
    /**
     * 納入先追加ダイアログOPEN
     */
    openDeliveryDialog () {
      let $func = 'openDeliveryDialog'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      // 得意先名を検索して表示する
      let $obj = this.customers.find(v => v.code === this.customer_code.code)
      this.customer_name = $obj.name

      // 納入先初期化
      this.addDelivery = null
      this.$refs.adddelivery_form.resetValidation()

      // ダイアログOPEN
      this.setOverlay()

      // 1秒待つ
      setTimeout(() => {
        // ダイアログOPEN
        this.deliveryDialog = true
        this.resetOverlay()
      }, 1000)
    },
    /**
     * 商品コード変更
     */
    changeProductCode () {
      let $func = 'changeProductCode'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      //   if (!this.product_code) {
      //     this.product_code = { name: '', code: '' }
      //   }

      // 商品コードが未設定の場合、初期化
      if (!this.product_code) {
        if (this.DEBUG) {
          console.log('初期化')
        }
        // 消去
        this.jan_code = null // JANコード
        this.standard = null // 規格
        this.tax_class = null // 課税区分
        this.tax = null // 課税区分(文字列)
        this.item_remark = null // 商品概要
        this.imageSrc = 'img.php?id=none' // 商品イメージ
        this.std_quantity = 0 // 入数
        this.unit = 0 // 単価
      } else {
        if (this.DEBUG) {
          console.log(
            'this.product_code.code = [' + this.product_code.code + ']'
          )
          console.log(JSON.stringify(this.products))
        }

        // 商品コードよりレコードを検索
        let $obj = this.products.find(v => v.code === this.product_code.code)

        // 入数
        this.std_quantity = $obj.quantity
        // JANコード
        this.jan_code = $obj.jan_code
        // 規格
        this.standard = $obj.standard
        // 課税区分
        this.tax_class = $obj.tax_class
        this.tax = this.getTaxClass(this.tax_class)

        this.unit = $obj.unit // 単価

        // イメージ画像変更
        this.imageSrc = 'img.php?id=' + this.product_code.code

        // 商品概要
        this.item_remark = $obj.remark
      }
      // 商品が変更されたので、ケース、数量を初期化
      this.case_num = 0 // ケース
      this.quantity = 0 // 数量

      // 3桁カンマ表示削除
      this.resetCommaDelimiter()
      // 入力コントロール
      this.inputConrl()
      // 金額計算
      this.changePrice()
      // 3桁カンマ表示
      this.setCommaDelimiter()
    },
    /**
     * 注文入力画面：ケース、数量入力制御
     */
    inputConrl () {
      let $func = 'inputConrl'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
      }

      // 入数>0の場合、ケース入力あり
      if (this.std_quantity > 0) {
        this.case_readonly = false
        this.case_clearable = true
      } else {
        this.case_num = null
        this.case_readonly = true
        this.case_clearable = false
      }
      this.case_clearable = !this.case_readonly
      this.quantity_readonly = !this.case_readonly
      this.quantity_clearable = !this.case_clearable

      this.case_num = this.case_num
    },
    /**
     * CSV出力実行
     */
    downloadCSV () {
      let $func = 'clickCsvOutputRegist'
      if (this.DEBUG) {
        console.log(
          '【' + $func + '】 ' + '(start)----------------------------------'
        )
        console.log('[' + $func + '] ' + '伝票番号 = ' + this.reportNo)
      }
      // ダイアログOPEN
      this.setOverlay()
      var csv = ''

      //   var csv =
      //     '\ufeff' +
      //     '削除マーク' +
      //     ',' +
      //     '締めフラグ' +
      //     ',' +
      //     'チェック' +
      //     ',' +
      //     '伝票日付' +
      //     ',' +
      //     '伝票番号' +
      //     ',' +
      //     '伝票区分' +
      //     ',' +
      //     '取引区分' +
      //     ',' +
      //     '税転嫁' +
      //     ',' +
      //     '金額端数処理' +
      //     ',' +
      //     '税端数処理' +
      //     ',' +
      //     '得意先コード' +
      //     ',' +
      //     '納入先コード' +
      //     ',' +
      //     '担当者コード' +
      //     ',' +
      //     '行番号' +
      //     ',' +
      //     '明細区分' +
      //     ',' +
      //     '商品コード' +
      //     ',' +
      //     '入金区分コード' +
      //     ',' +
      //     '商品名／入金内容' +
      //     ',' +
      //     '課税区分' +
      //     ',' +
      //     '単位' +
      //     ',' +
      //     '入数' +
      //     ',' +
      //     'ケース' +
      //     ',' +
      //     '倉庫コード' +
      //     ',' +
      //     '数量' +
      //     ',' +
      //     '単価' +
      //     ',' +
      //     '金額' +
      //     ',' +
      //     '回収予定日' +
      //     ',' +
      //     '税抜額' +
      //     ',' +
      //     '原価' +
      //     ',' +
      //     '原単価' +
      //     ',' +
      //     '備考' +
      //     ',' +
      //     '数量少数桁' +
      //     ',' +
      //     '単価少数桁' +
      //     ',' +
      //     '規格・型番' +
      //     ',' +
      //     '色' +
      //     ',' +
      //     'サイズ' +
      //     ',' +
      //     '納入期日' +
      //     ',' +
      //     '分類コード' +
      //     ',' +
      //     '伝票区分' +
      //     ',' +
      //     '得意先名称' +
      //     ',' +
      //     'プロジェクト主コード' +
      //     ',' +
      //     'プロジェクト副コード' +
      //     ',' +
      //     '予備１' +
      //     ',' +
      //     '予備２' +
      //     ',' +
      //     '予備３' +
      //     ',' +
      //     '予備４' +
      //     ',' +
      //     '予備５' +
      //     ',' +
      //     '予備６' +
      //     ',' +
      //     '予備７' +
      //     ',' +
      //     '予備８' +
      //     ',' +
      //     '予備９' +
      //     ',' +
      //     '予備１０' +
      //     ',' +
      //     '得意先略称' +
      //     ',' +
      //     '郵便番号' +
      //     ',' +
      //     '住所１' +
      //     ',' +
      //     '住所２' +
      //     ',' +
      //     'TEL' +
      //     ',' +
      //     'FAX' +
      //     '\n'
      let row = 0
      let isOutput = false
      this.selected.forEach(el => {
        isOutput = true
        let remark = el['remark']
        if (!remark) {
          remark = ''
        }
        let caseNum = el['case_num']
        if (!caseNum) {
          caseNum = 0
        }
        let quantity = el['quantity']
        if (!quantity) {
          quantity = 0
        }
        let unit = el['unit']
        if (!unit) {
          unit = 0
        }
        let excludingTax = el['excluding_tax']
        if (!excludingTax) {
          excludingTax = 0
        }

        row++
        var line =
          // 削除マーク
          '1' +
          ',' +
          // 締めフラグ
          '1' +
          ',' +
          // チェック
          '0' +
          ',' +
          // 伝票日付
          (!el['shipping_date']
            ? ''
            : moment(el['shipping_date']).format('YYYYMMDD')) +
          ',' +
          // 伝票番号
          (!this.reportNo ? '00000000' : this.reportNo) +
          ',' +
          // 伝票区分
          '24' +
          ',' +
          // 取引区分
          el['transaction_type'] +
          ',' +
          // 税転嫁
          el['tax_transfer'] +
          ',' +
          // 金額端数処理
          el['fractional_amount'] +
          ',' +
          // 税端数処理
          el['tax_fraction'] +
          ',' +
          // 得意先コード
          el['customer_code'] +
          ',' +
          // 納入先コード
          el['delivery_code'] +
          ',' +
          // 担当者コード
          '' +
          ',' +
          // 行番号
          row +
          ',' +
          // 明細区分
          '1' +
          ',' +
          // 商品コード
          el['product_code'] +
          ',' +
          // 入金区分コード
          '' +
          ',' +
          // 商品名／入金内容
          el['product_name'] +
          ',' +
          // 課税区分
          el['tax_class'] +
          ',' +
          // 単位
          el['std_unit'] +
          ',' +
          // 入数
          el['std_quantity'] +
          ',' +
          // ケース
          caseNum +
          ',' +
          // 倉庫コード
          '' +
          ',' +
          // 数量
          quantity +
          ',' +
          // 単価
          Number(unit).toFixed() +
          ',' +
          // 金額
          this.calTaxClass(
            el['tax class'],
            el['tax_fraction'],
            el['excluding_tax']
          ) +
          ',' +
          // 回収予定日
          '' +
          ',' +
          // 税抜額
          Number(excludingTax).toFixed() +
          ',' +
          // 原価
          '0' +
          ',' +
          // 原単価
          '0' +
          ',' +
          // 備考
          //  el['remark'] +
          remark +
          ',' +
          // 数量少数桁
          '2' +
          ',' +
          // 単価少数桁
          '2' +
          ',' +
          // 規格・型番
          el['standard'] +
          ',' +
          // 色
          '' +
          ',' +
          // サイズ
          '' +
          ',' +
          // 納入期日
          '' +
          ',' +
          // 分類コード
          '' +
          ',' +
          // 伝票区分
          '' +
          ',' +
          // 得意先名称
          el['customer_name'] +
          ',' +
          // プロジェクト主コード
          '' +
          ',' +
          // プロジェクト副コード
          '' +
          ',' +
          // 予備１
          '' +
          ',' +
          // 予備２
          '' +
          ',' +
          // 予備３
          '' +
          ',' +
          // 予備４
          '' +
          ',' +
          // 予備５
          '' +
          ',' +
          // 予備６
          '' +
          ',' +
          // 予備７
          '' +
          ',' +
          // 予備８
          '' +
          ',' +
          // 予備９
          '' +
          ',' +
          // 予備１０
          '' +
          ',' +
          // 得意先略称
          el['delivery_name'] +
          ',' +
          // 郵便番号
          '' +
          ',' +
          // 住所１
          '' +
          ',' +
          // 住所２
          '' +
          ',' +
          // TEL
          '' +
          ',' +
          // FAX
          '' +
          '\n'
        csv += line
        axios
          .post('/laravel/public/order/csv', {
            id: el['id'],
            slip_no: !this.reportNo ? '00000000' : this.reportNo,
            row_no: row
          })
          .then(response => {})
          .catch(error => {
            this.err = error.response.data.errors
          })
      })
      if (isOutput) {
        let blob = new Blob([csv], { type: 'text/csv' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = moment().format('YYYYMMDDHHmmss') + '.csv'
        link.click()
      }
      // 1秒待つ
      setTimeout(() => {
        // ダイアログOPEN
        this.csvOutputDialog = false
        this.resetOverlay()
      }, 1000)
    }
  },
  data () {
    return {
      // 注文入力ダイアログ
      orderDialog: false,

      isShipment: true,
      // 得意先マスタ選択情報
      selectCustomer: { name: '', code: '' },

      order_date_from: new Date().toISOString().substr(0, 10),
      order_date_to: null,
      shipping_date_from: null,
      shipping_date_to: null,
      delivery_date_from: null,
      delivery_date_to: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,

      status_00: false, // 注文確認待ち
      status_01: false, // 注文
      status_02: false, // 加工中
      status_03: false, // 出荷済
      status_04: false, // CSV出力済

      customers: null,
      selected: [],

      expand: false,
      headers: [
        // {
        //   text: null,
        //   value: 'csv',
        //   sortable: true,
        //   align: 'left',
        //   width: '20'
        // },
        {
          text: '注文状況',
          value: 'status',
          sortable: true,
          align: 'left',
          width: '100'
        },
        {
          text: '注文番号',
          value: 'order_id',
          sortable: true,
          align: 'left',
          width: '100'
        },
        {
          text: '得意先',
          value: 'customer_code',
          sortable: true,
          align: 'left'
        },
        {
          text: '納入先',
          value: 'delivery_code',
          sortable: true,
          align: 'left'
        },
        {
          text: '商品名',
          value: 'product_code',
          sortable: true,
          align: 'left'
        },
        { text: '規格', value: 'product_code', sortable: true, align: 'left' },
        {
          text: 'JANコード',
          value: 'product_code',
          sortable: true,
          align: 'left'
        },
        { text: '数量', value: 'quantity', sortable: true },
        { text: '単価', value: 'unit', sortable: true },
        { text: '金額(税込)', value: 'unit', sortable: true }
      ],
      items: [],
      loadFlag: false,

      // 注文情報選択データ
      id: null,
      order_id: null,
      order_date: new Date().toISOString().substr(0, 10),
      order_date_time: moment().format('HH:mm'),
      delivery_date: new Date().toISOString().substr(0, 10),
      shipping_date: new Date().toISOString().substr(0, 10),
      customer_code: { name: '', code: '' },
      delivery_code: { name: '', code: '' },
      product_code: { name: '', code: '' },
      jan_code: null,
      quantity: null,
      quantity_readonly: false,
      quantity_clearable: true,
      case_num: null,
      case_readonly: false,
      case_clearable: true,
      unit: null,
      remark: null,
      status: null,
      tax_class: null,
      tax_fraction: null,
      item_remark: null,
      imageSrc: 'img.php',
      price: null,
      excluding_tax: null,

      // 商品追加ダイアログ変数
      addUnit: null,
      addProduct: { name: '', code: '' },

      // 納入先ダイアログ
      addDelivery: null,
      customer_name: '得意先名称を表示する',

      // 注文状況一覧表示更新要
      refresh: false,

      menu11: false,
      menu12: false,
      menu13: false,
      menu14: false,

      customerDialog: false,
      productDialog: false,
      deliveryDialog: false,
      csvOutputDialog: false,
      reportNo: null,
      tax: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0
      },
      customerReadonly: null,
      CustomerInput: null,
      // 商品マスタ選択情報
      selectProduct: { name: '', code: '' },

      time: null,
      width: 300,
      products: [],
      productsall: [],
      deliverys: [],

      // 注文入力ダイアログ バリデーション
      customerRules: [v => !!v || '得意先は必須項目です'], // 得意先
      deliveryRules: [v => !!v || '納入先は必須項目です'], // 納入先
      productRules: [v => !!v || '商品は必須項目です'], // 商品

      // 商品追加ダイアログ バリデーション
      addProductCodeRules: [v => !!v || '商品は必須項目です'],
      addUnitRules: [v => !!v || '単価は必須項目です'],
      // 納入先追加ダイアログ バリデーション
      addDeliveryRules: [v => !!v || '納入先は必須項目です']
    }
  }
}
</script>
